import { forwardRef, ReactNode, useImperativeHandle, useState } from "react"
import { IoClose } from "react-icons/io5"

import BlurWrapper from "@fuse/sharedComponents/blurWrapper"

export interface InfoModalHandle {
  openModal: () => void
  closeModal: () => void
}

interface InfoModalProps {
  children?: ReactNode
}

const InfoModal = forwardRef<InfoModalHandle, InfoModalProps>(
  ({ children }, ref) => {
    const [isVisible, setIsVisible] = useState(false)

    useImperativeHandle(ref, () => ({
      openModal: () => setIsVisible(true),
      closeModal: () => setIsVisible(false),
    }))

    if (!isVisible) return null

    return (
      <div
        className="fixed inset-0 flex justify-center bg-black bg-opacity-50 z-50 items-end md:items-center place-items-center"
        onClick={() => setIsVisible(false)}
      >
        <BlurWrapper
          overlayOpacityDefault="20"
          className="w-full md:max-w-sm bg-white rounded-t-2xl md:rounded-2xl p-6 relative flex flex-col cursor-auto place-content-center"
          onClick={(e) => e.stopPropagation()}
        >
          {children}
        </BlurWrapper>
      </div>
    )
  },
)

export default InfoModal
